import { motion } from "framer-motion";
import { EXP } from "@/constants/testIds/ashwin";
import { experiences } from "@/data/resume";

export default function Experience() {
  return (
    <section
      id="experience"
      data-testid={EXP.root}
      className="py-24 md:py-40 border-t border-[color:var(--border)]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-8 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <div className="text-xs font-mono-editorial uppercase text-[color:var(--muted)] tracking-[0.15em] mb-6">
              03 — Work
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-light tracking-tight leading-[0.95]">
              A career <br />
              <span className="font-serif-accent italic">across categories.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 text-lg md:text-xl leading-relaxed text-[color:var(--charcoal)]/80">
            From pharma field forces of 12,000+ to brewery ops in Mysuru and retail launches
            across 450+ outlets &mdash; I&rsquo;ve built strategy inside the messy realities of the market.
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-0 md:left-[calc(25%-1px)] top-0 bottom-0 w-px bg-[color:var(--border)]" />

          <div className="space-y-16 md:space-y-24">
            {experiences.map((e, i) => (
              <motion.article
                key={i}
                data-testid={EXP.item(i)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="group grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12"
              >
                <div className="md:pr-8 relative">
                  <div className="absolute left-[-5px] md:left-auto md:right-[-5px] top-2 timeline-dot group-hover:bg-[color:var(--accent)] transition-colors" />
                  <div className="pl-6 md:pl-0 md:text-right">
                    <div className="font-mono-editorial text-xs uppercase tracking-[0.15em] text-[color:var(--muted)]">
                      {e.dates}
                    </div>
                    <div className="mt-2 text-sm text-[color:var(--muted)]">
                      {e.location}
                    </div>
                  </div>
                </div>

                <div className="md:col-span-3 md:pl-12">
                  <h3 className="font-display text-3xl md:text-4xl font-light tracking-tight leading-tight group-hover:text-[color:var(--accent)] transition-colors">
                    {e.company}
                  </h3>
                  <div className="mt-2 font-serif-accent italic text-lg md:text-xl text-[color:var(--charcoal)]/80">
                    {e.role}
                  </div>
                  <ul className="mt-6 space-y-3">
                    {e.bullets.map((b, bi) => (
                      <li
                        key={bi}
                        className="flex items-start gap-4 text-base md:text-lg leading-relaxed transition-transform duration-300 group-hover:translate-x-0.5"
                      >
                        <span className="mt-2 w-6 h-px bg-[color:var(--charcoal)] shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
